import React, {Component, createRef} from 'react'
import {connect} from 'react-redux'
import FJRecordingModal from "../view/FJRecordingModal";
import {FJRecordingAction, FJModalAction} from '../../../redux/action/FJRoot.action'
import FJCommonModal from "../../../common/component/modal/FJCommonModal";
import FJLocalStore from "../../../store/FJLocalStore";
import key from "keymaster";

class FJRecordingModalContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      width: 1032,
    };
    this._previewVideo = createRef();
  }

  componentDidMount() {
    this._upDateSize();
    window.addEventListener('resize', this._upDateSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._upDateSize);
  }

  _upDateSize = () => {
    if (document.body.getBoundingClientRect) {
      let bodyHeight = document.body.getBoundingClientRect().height;
      let bodyWidth = document.body.getBoundingClientRect().width;
      let width = 1032;
      if (bodyWidth <= 1180 || bodyHeight <= 800) {
        width = 716;
      }
      this.setState({
        width: width
      });
    }
  };

  /**
   * @description 关闭模态框
   * @private
   */
  _closeModal = (type) => {
    if (type === 'cancel') {
      setTimeout(() => {
        key.setScope('record');
      });
      return
    }
    this.props.setRecordingModalState(false);
    this._previewVideo.current.clearAll();
    if (this.props.currentStage === 4) {
      this._previewVideo.current.timeHide()
    }
  };

  /**
   * @description 点击退出
   * @private
   */
  _onCancel = () => {
    this._previewVideo.current.userClickClose()
  };

  onShow = () => {
    key.setScope('record');
  };

  onHide = () => {
    key.setScope('default');
  };

  render() {
    let {
      cancelText,
      submitText,
      cancelType,
      submitDanger,
      headerText,
      bodyText,


      visible,
      videoSource,
      videotapeSrc,
      screenRecordingType,
      cameraList,
      microphoneList,
      cameraActiveIndex,
      microphoneActiveIndex,
      changeRecordingConfig,
      currentStage,
      setCurrentStage,
      onReRecord,
      onCancel,
      onSubmit,
      startVideoBegins,
      endRecording,

    } = this.props;

    let title;
    if (currentStage < 6) {
      title = FJLocalStore._('record-webcam');
    } else if (currentStage === 6) {
      title = FJLocalStore._('preview-photo');
    } else {
      title = FJLocalStore._('preview-video');
    }

    return (
      <FJCommonModal visible={visible}
                     width={this.state.width + 'px'}
                     hasOuterCloseBtn
                     hasOuterTitle
                     title={title}
                     onShow={this.onShow}
                     onHide={this.onHide}
                     onCancel={this._onCancel}
      >
        <FJRecordingModal ref={this._previewVideo}
                          videoSource={videoSource}
                          videotapeSrc={videotapeSrc}
                          screenRecordingType={screenRecordingType}
                          onReRecord={() => {
                               onReRecord ? onReRecord(this._closeModal) : this._closeModal();
                             }}
                          onCancel={(currentStage, recordType) => {
                               onCancel ? onCancel(this._closeModal, currentStage, recordType) : this._closeModal();
                             }}
                          onSubmit={(imgUrl, duration) => {
                               onSubmit ? onSubmit(this._closeModal, imgUrl, duration) : this._closeModal();
                             }}
                          startVideoBegins={startVideoBegins}
                          endRecording={endRecording}
                          cameraList={cameraList}
                          microphoneList={microphoneList}
                          cameraActiveIndex={cameraActiveIndex}
                          microphoneActiveIndex={microphoneActiveIndex}
                          changeRecordingConfig={changeRecordingConfig}
                          setCurrentStage={setCurrentStage}
                          currentStage={currentStage}

                          headerText={headerText}
                          bodyText={bodyText}
                          cancelText={cancelText}
                          submitText={submitText}
                          cancelType={cancelType}
                          submitDanger={submitDanger}
                          videoHeight={this.state.width / (16/9)}


        />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowRecordingModal,
    videoSource: state.recording.videoSource,
    videotapeSrc: state.recording.videotapeSrc,
    screenRecordingType: state.recording.screenRecordingType,
    cameraList: state.recording.cameraList, // 摄像头列表
    microphoneList: state.recording.microphoneList, // 麦克风列表
    cameraActiveIndex: state.recording.cameraActiveIndex,
    microphoneActiveIndex: state.recording.microphoneActiveIndex,
    currentStage: state.recording.currentStage
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    onCancel: function (callback, currentStage, recordType) {
      dispatch(FJRecordingAction.onCancelAction(callback, currentStage, recordType));
    },
    onSubmit: function (callback, imgUrl, duration) {
      dispatch(FJRecordingAction.onSubmitAction(callback, imgUrl, duration));
    },
    onReRecord: function (callback) {
      dispatch(FJRecordingAction.onReRecordAction(callback));
    },
    setRecordingModalState: function (boolean) {
      dispatch(FJModalAction.setIsShowRecordingModalAction(boolean));
    },
    startVideoBegins: function () {
      dispatch(FJRecordingAction.startVideoBeginsAction());
    },
    endRecording: function () {
      FJRecordingAction.endRecordingScreenAction()
    },
    changeRecordingConfig: function (type, index) {
      dispatch(FJRecordingAction.changeRecordingConfigAction(type, index));
    },
    setCurrentStage: function (data) {
      dispatch(FJRecordingAction.setCurrentStageAction(data));
    }

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJRecordingModalContainer);
